{
  "it": {
    "headlines": {
      "vehiclePlaque": {
        "title": "Targa di dedica"
      },
      "vehicleOverview": {
        "paints": "Verniciature %{model}",
        "location": "Dov'è la nave?",
        "picture": "Immagine della nave"
      },
      "vehicleLog": {
        "create": "Nuova voce del diario",
        "edit": "Modifica voce del diario",
        "public": "Diario di bordo: %{vehicle}"
      },
      "hangarShare": "Link di condivisione",
      "locations": {
        "index": "Luoghi",
        "places": "Tutti i luoghi"
      },
      "admin": {
        "locations": {
          "index": "Luoghi"
        },
        "blueprints": {
          "index": "Progetti",
          "materials": "Materiali",
          "stats": "Statistiche",
          "sources": "Fonti"
        },
        "missions": {
          "index": "Missioni"
        },
        "dashboard": {
          "title": "Pannello di controllo",
          "visitsPerDay": "Visite al giorno",
          "visitsPerMonth": "Visite al mese",
          "mostViewedPages": "Pagine più visitate",
          "registrationsPerMonth": "Registrazioni al mese"
        },
        "models": {
          "index": "Modelli",
          "edit": {
            "index": "Modifica modello",
            "fleetchart": "Immagini grafico flotta",
            "positions": "Posizioni dell'equipaggio",
            "hardpoints": "Punti di montaggio",
            "cargoAndFuel": "Carburante",
            "cargoHolds": "Stive di carico",
            "metrics": "Metriche",
            "prices": "Prezzi",
            "docks": "Dock",
            "modules": "Moduli",
            "paints": "Verniciature",
            "videos": "Video",
            "images": "Immagini",
            "itemPrices": "Prezzi degli articoli",
            "linkModule": "Collega modulo esistente",
            "loaners": "Prestiti",
            "snubCrafts": "Snub Craft",
            "upgrades": "Upgrade",
            "packages": "Pacchetti",
            "linkUpgrade": "Collega upgrade esistente",
            "history": "Cronologia"
          },
          "new": "Nuovo modello",
          "show": "Modello",
          "images": "Immagini",
          "tableConfigurationModal": "Configurazione tabella"
        },
        "components": {
          "index": "Componenti",
          "new": "Nuovo componente",
          "edit": {
            "index": "Modifica componente",
            "itemPrices": "Prezzi degli articoli",
            "history": "Cronologia"
          }
        },
        "modelPaints": {
          "index": "Verniciature",
          "new": "Nuova verniciatura",
          "edit": "Modifica verniciatura",
          "copy": "Copia verniciatura su nave",
          "bulkCopy": "Copia %{count} verniciature su nave"
        },
        "modelModules": {
          "index": "Moduli",
          "new": "Nuovo modulo",
          "edit": "Modifica modulo",
          "models": "Modelli collegati",
          "prices": "Prezzi",
          "hardpoints": "Punti di montaggio",
          "docks": "Dock",
          "cargoHolds": "Stive di carico",
          "history": "Cronologia"
        },
        "unlistedModels": {
          "index": "Navi nei file di gioco senza modello",
          "link": "Collega a una nave del catalogo"
        },
        "manufacturers": {
          "index": "Produttori",
          "new": "Nuovo produttore",
          "edit": {
            "index": "Modifica produttore"
          }
        },
        "announcements": {
          "index": "Annunci",
          "new": "Nuovo annuncio",
          "edit": "Modifica annuncio",
          "deliveries": "Consegna",
          "manualPosts": "Post da copiare"
        },
        "supporterContributions": {
          "index": "Contributi dei sostenitori",
          "new": "Nuovo contributo",
          "edit": "Modifica contributo",
          "perMonth": "Contributi al mese"
        },
        "fundingGoals": {
          "index": "Obiettivi di finanziamento",
          "new": "Nuovo obiettivo di finanziamento",
          "edit": "Modifica obiettivo di finanziamento"
        },
        "users": {
          "index": "Utenti",
          "edit": "Modifica utente",
          "fleets": "Flotte",
          "inventories": "Inventari",
          "supporterContributions": "Contributi dei sostenitori"
        },
        "vehicles": {
          "index": "Veicoli",
          "edit": "Modifica veicolo"
        },
        "fleets": {
          "index": "Flotte",
          "edit": "Modifica flotta",
          "members": "Membri",
          "memberEdit": "Modifica membro",
          "history": "Cronologia",
          "roles": "Ruoli",
          "inventories": "Inventari",
          "inventoryItems": "Voci"
        },
        "fleetFidClaims": {
          "index": "Rivendicazioni di ID flotta"
        },
        "destroyedFleets": {
          "index": "Flotte eliminate"
        },
        "admins": {
          "index": "Amministratori",
          "new": "Nuovo amministratore",
          "edit": "Modifica amministratore"
        },
        "oauthApplications": {
          "index": "Applicazioni OAuth",
          "new": "Nuova applicazione OAuth",
          "edit": "Modifica applicazione OAuth",
          "reject": "Rifiuta %{name}",
          "rejectBulk": "Rifiuta %{count} applicazioni"
        },
        "features": {
          "index": "Flag funzionalità",
          "show": "Dettagli funzionalità",
          "globalState": "Stato globale",
          "groups": "Gruppi",
          "actors": "Attori",
          "selfService": "Self-service",
          "percentageOfActors": "Percentuale degli attori",
          "percentageOfTime": "Percentuale di tempo",
          "addActor": "Aggiungi attore",
          "history": "Cronologia",
          "addUser": "Abilita per un utente",
          "addFleet": "Abilita per una flotta",
          "enabledUsers": "Utenti abilitati",
          "enabledFleets": "Flotte abilitate"
        },
        "rsiApiStatus": {
          "index": "Stato API RSI"
        },
        "images": {
          "index": "Immagini"
        },
        "imports": {
          "index": "Importazioni"
        },
        "notifications": {
          "index": "Notifiche"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Edit Equipment",
            "itemPrices": "Item Prices"
          }
        },
        "visualTests": {
          "index": "Test Visivi",
          "notifications": "Notifiche"
        },
        "buildCompare": {
          "index": "Confronto build"
        }
      },
      "welcome": "Benvenuto su",
      "welcomeShips": "Ultime Navi",
      "welcomeImages": "Immagini Casuali",
      "ships": {
        "index": "Indice Delle Navi",
        "fleetchart": "Grafico flotta navi"
      },
      "images": "Indice Delle Immagini",
      "stats": "Statistiche",
      "notFound": "Errore di Navigazione",
      "forbidden": "Accesso negato",
      "subscriptionRequired": "Funzione dei sostenitori",
      "featureNotReady": "In arrivo",
      "inviteInvalid": "Link di invito non valido",
      "accessDenied": "Accesso negato",
      "serverError": "Errore del server",
      "offline": "Connessione persa",
      "invalidRequest": "Richiesta non valida",
      "comments": "Commenti",
      "login": "Accedi",
      "hangar": {
        "index": "Il Mio Hangar",
        "preview": {
          "title": "Il tuo hangar",
          "lead": "Tieni traccia di ogni nave che possiedi — gratis con un account FleetYards.net."
        },
        "alternativeNames": "Nomi alternativi",
        "stats": "Statistiche",
        "public": "Hangar di %{user}",
        "import": "Importa",
        "wishlist": "Lista dei desideri",
        "publicStats": "Statistiche",
        "publicWishlist": "Lista dei desideri di %{user}",
        "resetIngame": "Resetta le navi in gioco dopo il wipe",
        "buybacks": "Pledge riacquistabili",
        "paints": "Verniciature",
        "flair": "Decorazioni per l'hangar",
        "upgrades": "Potenziamenti / CCU",
        "equipment": "Equipaggiamento FPS",
        "imports": "Importazioni"
      },
      "buybackSync": "Sincronizza i pledge riacquistabili RSI",
      "syncExtension": "Sincronizza hangar RSI",
      "editMyVehicle": "Modifica il mio %{vehicle}",
      "vehicleLoadout": "Configurazione per %{vehicle}",
      "nameMyVehicle": "Dai un nome al mio %{vehicle}",
      "editGroups": "Modifica i Gruppi",
      "newVehicles": "Aggiungi Navi",
      "myVehicleAddons": "Aggiungi Moduli / Upgrades per %{vehicle}",
      "myVehicleLoadouts": "Loadouts per %{vehicle}",
      "addToHangar": "Aggiungi \"%{model}\" al tuo Hangar",
      "impressum": "Info legali",
      "privacy": "Informativa sulla privacy",
      "cookie": "Informativa sui Cookie",
      "requestPassword": "Richiedi la password",
      "changePassword": "Cambia la password",
      "confirmAccess": "Conferma l'accesso",
      "setEmail": "Imposta il tuo indirizzo email",
      "oauthAuthorize": "Autorizza applicazione",
      "filterModels": "Filtra Le Navi",
      "filterVehicles": "Filtra Hangar",
      "fleets": {
        "directory": "Directory delle flotte",
        "owners": "Proprietari",
        "add": "Crea una nuova flotta",
        "invites": "Inviti Alla Flotta",
        "inviteUrls": "URL d'invito",
        "members": {
          "index": "Members",
          "worldmap": "Mappa mondiale dei membri",
          "starmap": "Mappa stellare dei membri",
          "health": "Stato dei membri"
        },
        "squadrons": {
          "index": "Squadroni",
          "create": "Crea squadrone",
          "edit": "Modifica squadrone",
          "formDetails": "Dettagli",
          "formAppearance": "Aspetto",
          "formDiscord": "Discord",
          "ranks": "Gradi di squadrone",
          "editMember": "Modifica membro dello squadrone",
          "editRank": "Modifica grado di squadrone",
          "teams": "Squadre",
          "addMembers": "Aggiungi membri",
          "members": "Membri"
        },
        "stats": "Statistiche",
        "preview": {
          "title": "La tua flotta",
          "lead": "Riunisci la tua org — gratis con un account FleetYards.net."
        },
        "settings": {
          "fleet": "Impostazioni Della Flotta",
          "rsi": "ID flotta e RSI",
          "membership": "Impostazioni dei Membri",
          "roles": "Ruoli flotta",
          "squadrons": "Squadroni della flotta",
          "allies": "Alleati della flotta",
          "notifications": "Impostazioni Notifiche",
          "inAppNotifications": "Notifiche in-app",
          "discord": "Discord",
          "calendar": "Calendario",
          "contracts": "Impostazioni contratti",
          "features": "Funzionalità della flotta"
        },
        "inviteMember": "Invita nuovo membro",
        "calendarSubscription": "Abbonamento al calendario",
        "missions": {
          "index": "Missioni",
          "create": "Crea missione",
          "edit": "Modifica missione",
          "editDetails": "Dettagli",
          "editDescription": "Descrizione e copertina",
          "editTeams": "Team e slot",
          "teams": "Team",
          "ships": "Navi",
          "slots": "Slot",
          "addTeam": "Aggiungi team",
          "editTeam": "Modifica team",
          "addShip": "Aggiungi nave",
          "editShip": "Modifica nave"
        },
        "events": {
          "expandShip": "Aggiungi posti",
          "index": "Eventi",
          "calendar": "Calendario",
          "create": "Crea evento",
          "edit": "Modifica evento",
          "editDetails": "Dettagli",
          "editSchedule": "Programmazione",
          "editSignup": "Iscrizione",
          "editDescription": "Descrizione e copertina",
          "editTeams": "Team e slot",
          "spawn": "Genera evento",
          "details": "Dettagli evento",
          "schedule": "Programmazione",
          "settings": "Impostazioni",
          "lifecycle": "Ciclo di vita",
          "signupTitle": "Iscrivimi",
          "yourSignup": "La tua iscrizione",
          "spawnedFrom": "Generato da questa missione",
          "pickTemplate": "Scegli un modello di missione",
          "unassignedSignups": "Iscrizioni non assegnate",
          "eventTeam": "Team dell'evento",
          "grantRole": "Assegna un ruolo",
          "editTeam": "Modifica team",
          "addTeam": "Aggiungi team",
          "editShip": "Modifica nave",
          "addShip": "Aggiungi nave",
          "assignSlotFor": "Assegna slot a %{username}",
          "reassignSlotFor": "Riassegna slot a %{username}"
        },
        "memberNickname": "Soprannome del membro",
        "editRole": "Modifica ruolo",
        "contracts": {
          "index": "Contratti",
          "create": "Crea contratto",
          "edit": "Modifica contratto",
          "progress": "Avanzamento",
          "crew": "Equipaggio",
          "items": "Merci",
          "editItem": "Modifica merci",
          "addItem": "Aggiungi merci",
          "views": {
            "open": "Contratti",
            "closed": "Contratti chiusi",
            "mine": "I miei contratti",
            "completed": "Contratti completati"
          }
        }
      },
      "hangarGroup": {
        "create": "Crea Gruppo",
        "edit": "Modifica Gruppo"
      },
      "compare": {
        "ships": "Confronta Navi"
      },
      "settings": {
        "account": "Profilo",
        "profile": "Impostazioni del Profilo",
        "hangar": "Impostazioni dell'Hangar",
        "privacy": "Impostazioni Privacy",
        "features": "Flag funzionalità",
        "connections": "Connessioni",
        "oauthApplications": "Applicazioni OAuth",
        "notifications": "Impostazioni Notifiche",
        "verify": "Verifica il tuo account RSI",
        "security": {
          "index": "Sicurezza dell'account",
          "twoFactor": "Autenticazione a due fattori"
        },
        "twoFactor": {
          "enable": "Attiva Autenticazione A Due Fattori",
          "disable": "Disattiva Autenticazione A Due Fattori",
          "backupCodes": "Genera Codici Di Backup Autenticazione a Due Fattori"
        },
        "calendar": "Abbonamento al calendario",
        "donations": "Donazioni"
      },
      "oauthApplications": {
        "new": "Nuova applicazione OAuth",
        "edit": "Modifica applicazione OAuth"
      },
      "roadmap": "Roadmap Delle Navi",
      "tools": {
        "index": "Strumenti",
        "travelTimes": "Tempi di viaggio",
        "cargoGrids": "Griglie di carico",
        "tradeRoutes": "Rotte commerciali"
      },
      "rsiVerification": "Verifica il tuo account RSI",
      "support": "Supporta FleetYards.net",
      "supporters": "Grazie ai nostri sostenitori",
      "installApp": {
        "offer": "Porta FleetYards con te",
        "ios": "Installa FleetYards"
      },
      "supportHint": {
        "hangarSync": "Felici di averti aiutato con la sincronizzazione",
        "vehicleAdded": "Il tuo hangar sta crescendo",
        "fleetCreated": "Una nuova flotta — ottimo!",
        "loginMilestone": "Grazie per essere ancora qui",
        "visitMilestone": "Ti piace FleetYards?"
      },
      "vehicle": {
        "bulkGroupEdit": "Aggiungi/rimuovi Gruppi"
      },
      "pagination": {
        "count": "%{current} di %{total}"
      },
      "models": {
        "index": "Modelli"
      },
      "modals": {
        "models": {
          "displayOptions": "Opzioni di visualizzazione"
        }
      },
      "visualTests": {
        "overview": "Panoramica",
        "panels": "Pannelli",
        "buttons": "Pulsanti",
        "media": "Media",
        "charts": "Grafici",
        "blueprints": "Progetti",
        "squadrons": "Squadroni",
        "alerts": "Avvisi",
        "verifiedBadges": "Badge di verifica",
        "chips": "Chips Test Visivi",
        "events": "Eventi",
        "typography": "Tipografia",
        "forms": "Moduli",
        "tables": "Tabelle",
        "lists": "Elenchi",
        "metrics": "Metriche",
        "states": "Stati",
        "notifications": "Notifiche",
        "dedicationPlaques": "Targhe di dedica",
        "syncModal": "Modal sincronizzazione",
        "buybackSyncModal": "Modale sincronizzazione riacquisti",
        "rsiVerificationModal": "Modale verifica RSI",
        "fleetRsiVerificationModal": "Modale verifica RSI della flotta",
        "overlays": "Overlay",
        "installPrompt": "Invito all'installazione",
        "supportHint": "Suggerimento supporto",
        "notificationCenter": "Centro notifiche",
        "themes": "Temi"
      },
      "logistics": {
        "index": "Logistics",
        "inventories": "Inventories",
        "requests": "Requests",
        "newRequest": "New Request",
        "requestItems": "Items",
        "comments": "Comments",
        "inventoryItems": "Inventory Items",
        "createInventory": "Create Inventory",
        "editInventory": "Edit Inventory",
        "createItem": "Add Item",
        "deposit": "Deposit",
        "withdrawal": "Withdrawal",
        "importCsv": "Import from CSV",
        "hangarInventories": "Hangar Inventories",
        "editItem": "Edit Entry",
        "editStockItem": "Edit Item",
        "transfer": "Trasferisci scorte",
        "transfers": "Trasferimenti",
        "acceptTransfer": "Accetta trasferimento",
        "reportTransfer": "Segnala trasferimento"
      },
      "notifications": {
        "index": "Notifiche"
      },
      "payouts": {
        "index": "Pagamenti",
        "summary": "Riepilogo",
        "participants": "Partecipanti",
        "entries": "Movimenti",
        "balances": "Saldi",
        "transfers": "Elenco pagamenti",
        "addEntry": "Registra denaro",
        "editEntry": "Modifica movimento",
        "addParticipant": "Aggiungi partecipante",
        "tours": {
          "index": "Spedizioni",
          "create": "Crea spedizione",
          "join": "Unisciti a questa spedizione"
        },
        "declineExpense": "Rifiuta la spesa"
      },
      "relationships": {
        "user": {
          "index": "Amici",
          "add": "Aggiungi un amico"
        },
        "fleet": {
          "add": "Aggiungi un alleato"
        }
      },
      "fleet": {
        "contractCovers": "Copertine dei contratti"
      },
      "component": {
        "temperature": "Temperatura",
        "misfire": "Malfunzionamento",
        "history": "Cronologia",
        "craftedFrom": "Fabbricato con",
        "identity": "Dettagli",
        "metrics": "Valori",
        "requiredTags": "Si monta su una porta con",
        "tags": "Tag",
        "physical": "Fisico",
        "damageTaken": "Danni subiti",
        "durability": "Durabilità",
        "selfRepair": "Autoriparazione",
        "distortion": "Distorsione",
        "splineJump": "Salto in orbita"
      },
      "commodity": {
        "priceHistory": "Storico prezzi",
        "identity": "Dettagli",
        "usedIn": "Usata in"
      },
      "commodities": {
        "index": "Merci"
      },
      "components": {
        "index": "Componenti"
      },
      "blueprints": {
        "index": "Progetti"
      },
      "missions": {
        "index": "Missioni"
      },
      "missions": {
        "index": "Missioni"
      },
      "equipment": {
        "index": "Equipaggiamento",
        "metrics": "Valori",
        "identity": "Dettagli",
        "craftedFrom": "Fabbricato con"
      }
    }
  }
}
